<template>
  <div
    ref="modal"
    class="modal fade"
    tabindex="-1"
    aria-labelledby="staticBackdropLabel"
    aria-hidden="true"
  >
    <div
      class="
        modal-dialog
        modal-dialog-centered
        modal-xxl
        modal-fullscreen-lg-down
        modal-dialog-scrollable
      "
    >
      <div class="modal-content">
        <div class="modal-header">
          <button
            type="button"
            class="btn btn-toolbar"
            :aria-label="$t(`cataloge.back`)"
            v-on:click="back()"
            v-if="editItem || showProducts"
          >
            <BaseIcon name="left-arrow2" />
          </button>
          <h5 class="modal-title" id="staticBackdropLabel">
            {{ $t("manufacturingOperationsModal.manufacturingOperations") }}
          </h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            :aria-label="$t(`addNewContactsModal.close`)"
          ></button>
        </div>
        <div class="modal-body" ref="modalBody">
          <div v-show="!showProducts">
            <draggable
              class="dragArea row custom-input whitebg-input"
              tag="ul"
              :list="operationSteps"
              :group="{ name: 'g1' }"
              item-key="id"
              filter="input, textarea"
              :prevent-on-filter="false"
              v-bind="dragOptions"
              :forceFallback="true"
              :scroll="true"
              :scrollSensitivity="100"
            >
              <template #item="{ element, index }">
                <li class="row">
                  <div class="col-1" v-if="index === 0"></div>
                  <div class="col-1" v-else>
                    <label
                      class="form-label bold-12 text-gray overflow-hidden"
                      >{{ $t("manufacturingOperationsModal.parallel") }}</label
                    >
                    <label class="cstm-check mt-3 mb-4">
                      <input
                        type="checkbox"
                        :value="true"
                        :disabled="lockData && lock"
                        v-model="element.parallel"
                      />
                      <span class="checkmark"></span>
                    </label>
                  </div>
                  <div class="col-2">
                    <div class="mb-3">
                      <label class="form-label bold-12 text-gray">{{
                        $t(`manufacturingOperationsModal.step`, {
                          ordinal_suffix_of: ordinal_suffix_of(index),
                        })
                      }}</label>
                      <v-select
                        v-model="element.id"
                        taggable
                        :reduce="(e) => e.id"
                        :options="
                          focusedIndex === index
                            ? filteredOperations
                            : operations
                        "
                        v-on:input="focusedIndex = index"
                        v-on:open="focusedIndex = index"
                        v-on:search="filterOperations"
                        :filterable="false"
                        :create-option="(v) => createOption(v)"
                        v-on:option:selected="(e) => selectedItem(e)"
                        label="name"
                        :disabled="lockData && lock"
                        append-to-body
                      />
                    </div>
                  </div>
                  <div class="col-2 col-xxl-3">
                    <div class="mb-3">
                      <label class="form-label bold-12 text-gray">{{
                        $t("manufacturingOperationsModal.description")
                      }}</label>
                      <v-select
                        v-model="element.description"
                        taggable
                        :options="opearationDescriptions[index]"
                        v-on:search="
                          (q, l) =>
                            searchOpearationDescriptions(element, index, q, l)
                        "
                        v-on:focusin="
                          searchOpearationDescriptions(
                            element,
                            index,
                            '',
                            (e) => {},
                            true
                          )
                        "
                        :disabled="lockData && lock"
                        :filterable="true"
                        append-to-body
                      >
                        <template v-slot:selected-option="option">
                          {{ option.label }}
                        </template>
                        <template v-slot:option="option">
                          <span class="regular-10">{{ option.label }}</span>
                        </template>
                      </v-select>
                    </div>
                  </div>
                  <div class="col-2 col-xxl-3">
                    <label class="form-label bold-12 text-gray">{{
                      $t("manufacturingOperationsModal.more2")
                    }}</label>
                    <textarea
                      class="form-control w-100"
                      v-model="element.extra_info"
                      :disabled="lockData && lock"
                    />
                  </div>
                  <div class="col">
                    <label class="form-label bold-12 text-gray">{{
                      $t("manufacturingOperationsModal.time")
                    }}</label>
                    <div class="fix-end-input">
                      <input
                        type="number"
                        v-model="element.time"
                        class="form-control"
                        :disabled="lockData && lock"
                        min="1"
                      />
                      <span>{{ $t("manufacturingOperationsModal.sec") }}</span>
                    </div>
                  </div>
                  <div class="col-auto">
                    <button
                      class="mt-4 btn btn-secondary btn-sm btn-no-r"
                      :title="$t(`manufacturingOperationsModal.getTimes`)"
                      v-on:click="getTimes(element)"
                    >
                      <BaseIcon name="clock" />
                    </button>
                    <button
                      class="mt-4 btn btn-secondary btn-sm btn-no-r btn-no-l"
                      :title="$t(`manufacturingOperationsModal.manageVideos`)"
                      v-on:click="editVideos(element)"
                    >
                      <BaseIcon name="video" />
                    </button>
                    <button
                      class="mt-4 btn btn-secondary btn-sm btn-no-r btn-no-l"
                      v-on:click="addRow(index)"
                    >
                      <BaseIcon name="plus" />
                    </button>
                    <button
                      class="mt-4 btn btn-secondary btn-sm btn-no-l"
                      v-on:click="deleteRow(index)"
                    >
                      <BaseIcon name="trash" />
                    </button>
                  </div>
                </li>
              </template>
            </draggable>
          </div>
          <div v-if="showProducts">
            <DynamicTable
              v-model:rows="rows"
              v-model:items="products"
              :fix-height="false"
              :show-order="false"
              :show-pin="false"
              type="operations"
              :key="tableKey"
            />
          </div>
        </div>
        <div class="modal-footer">
          <div class="row mt-4 w-100">
            <div class="col-6">
              <label class="cstm-check d-flex">
                <span class="regular-12 text-black mt-3">
                  {{ $t("ingredients.lock") }}
                </span>
                <input
                  type="checkbox"
                  v-model="lockData"
                  :value="true"
                  v-on:change="save(true)"
                />
                <span class="checkmark mt-3"></span>
              </label>
            </div>
            <div class="col-6 text-end">
              <button
                class="btn btn-type-2"
                v-if="!editItem"
                v-on:click="save()"
                :disabled="lockData && lock"
              >
                <span>{{ $t("finance.save") }}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <Videos v-model:show="showVideo" :id="id" type="operation" />
  <ConfirmModal
    ref="createModal"
    :title="$t(`manufacturingOperationsModal.createOperation`)"
    :text="`<ul><li>You will create a new operation<b></li></ul><p>Are you sure you want to continue?</p>`"
    cancel-button="No, cancel"
    :ok-button="`Yes, create ${createObject?.name}`"
    v-on:success="createOperation"
  />
</template>

<script>
import tenant from "../../modules/tenant";

const bootstrap = require("bootstrap");
import http from "@/modules/http";
import { useStore } from "vuex";
import draggable from "vuedraggable";
import BaseIcon from "../icons/BaseIcon";
import Videos from "@/components/inputs/Videos";
import ConfirmModal from "./ConfirmModal.vue";
import DynamicTable from "../lists/DynamicTable.vue";

export default {
  name: "ManufacturingOperationsModal",
  props: {
    modelValue: Array,
    id: Number,
    lock: Boolean,
  },
  components: { DynamicTable, ConfirmModal, BaseIcon, draggable, Videos },
  data() {
    return {
      dragOptions: {
        animation: 200,
        group: "description",
        disabled: false,
        ghostClass: "ghost",
      },
      showProducts: false,
      products: [],
      createObject: null,
      scrollTop: 0,
      editItem: null,
      store: useStore(),
      myModal: undefined,
      operationSteps: [{ id: null }],
      showVideo: false,
      editVideoData: null,
      lockData: this.lock,
      previousSearches: {},
      opearationDescriptions: {},
      filterQ: "",
      focusedIndex: 0,
      tableKey: 0,
      rows: [
        {
          name: "Image",
          key: "image",
          type: "image",
          show: true,
          editable: false,
        },
        {
          name: "Serial",
          key: "serial",
          type: "string",
          show: true,
          editable: false,
        },
        {
          name: "Time",
          key: "time",
          type: "number",
          show: true,
          editable: false,
        },
        {
          name: "Description",
          key: "description",
          type: "string",
          show: true,
          editable: false,
        },
        {
          name: "Extra info",
          key: "extra_info",
          type: "string",
          show: true,
          editable: false,
        },
      ],
      columnNumbers: [
        this.$t("serialNumbers.first"),
        this.$t("serialNumbers.second"),
        this.$t("serialNumbers.third"),
        this.$t("serialNumbers.fourth"),
        this.$t("serialNumbers.fifth"),
        this.$t("serialNumbers.sixth"),
        this.$t("serialNumbers.seventh"),
        this.$t("serialNumbers.eighth"),
        this.$t("serialNumbers.ninth"),
        this.$t("serialNumbers.tenth"),
      ],
    };
  },
  computed: {
    mediaServer() {
      return tenant.getAppMediaUrl();
    },
    operations() {
      return this.store.state.operations;
    },
    filteredOperations() {
      if (this.filterQ.length < 2) {
        return this.operations;
      }

      const searchTerm = this.filterQ.toLowerCase();

      return this.operations
        .filter(
          (item) => item.name && item.name.toLowerCase().includes(searchTerm)
        )
        .sort((a, b) => {
          const startsWithA = a.name.toLowerCase().startsWith(searchTerm);
          const startsWithB = b.name.toLowerCase().startsWith(searchTerm);

          if (startsWithA && !startsWithB) return -1;
          if (!startsWithA && startsWithB) return 1;

          return a.name.localeCompare(b.name);
        });
    },
  },
  methods: {
    ordinal_suffix_of(i, asText = false) {
      if (i > 0 && this.operationSteps[i]?.parallel) {
        return this.ordinal_suffix_of(i - 1);
      }
      if (asText && i < 10) {
        return this.columnNumbers[i];
      }
      i++;
      if (this.$i18n.locale !== "en") {
        return i + ".";
      }
      let j = i % 10,
        k = i % 100;
      if (j === 1 && k !== 11) {
        return i + "st";
      }
      if (j === 2 && k !== 12) {
        return i + "nd";
      }
      if (j === 3 && k !== 13) {
        return i + "rd";
      }
      return i + "th";
    },
    showModal() {
      this.operationSteps = [];
      for (const val of this.modelValue) {
        this.operationSteps.push({
          id: val.id,
          parallel: val.parallel ?? val.pivot?.parallel,
          time: val.time ?? val.pivot.time,
          description: val.description ?? val.pivot?.description ?? "",
          extra_info: val.extra_info ?? val.pivot?.extra_info ?? "",
          step_id: val.step_id ?? val.pivot?.id ?? null,
        });
      }
      this.operationSteps.push({ id: null });

      if (this.myModal === undefined) {
        this.myModal = new bootstrap.Modal(this.$refs.modal, {
          backdrop: "static",
        });
      }
      this.myModal.show();
    },
    addRow(index) {
      this.operationSteps.splice(index + 1, 0, { id: null });
    },
    deleteRow(index) {
      if (this.operationSteps.length > 1) {
        this.operationSteps.splice(index, 1);
      }
    },
    createOption(v) {
      let i = this.operations.find(
        (e) => e.name.toLowerCase().indexOf(v.toLowerCase()) > -1
      );
      if (i !== null && i !== undefined) {
        return i;
      }
      return { id: 0, name: v };
    },
    createOperation() {
      http
        .fetch(`/manufacturing/operations`, { name: this.createObject.name })
        .then((data) => {
          this.createObject.id = data.id;
          this.operations.push(data);
          for (const p in this.operationSteps) {
            if (this.operationSteps[p].id === 0) {
              this.operationSteps[p].id = data.id;
            }
          }
          this.createObject = null;
        });
    },
    selectedItem(e) {
      if (e.id === 0) {
        this.createObject = e;
        this.$refs.createModal.showModal();
      }
      let hasNull = false;
      for (const p in this.operationSteps) {
        if (this.operationSteps[p].id === null) {
          if (p !== this.operationSteps.length - 1) {
            this.operationSteps.splice(p, 1);
          } else {
            hasNull = true;
          }
        }
      }
      if (!hasNull) {
        this.operationSteps.push({ id: null });
      }
    },
    getTimes(e) {
      http
        .fetch(
          `/manufacturing/operations/descriptions/times?q=${e.description}&id=${e.id}&category_filter_by_product_id=${this.id}`
        )
        .then((data) => {
          for (const product of data) {
            product.image =
              product.image !== null
                ? product.image.indexOf("http") === 0
                  ? product.image
                  : this.mediaServer + "/" + product.image
                : null;
          }
          this.products = data;
          this.showProducts = true;
        });
    },
    editVideos(e) {
      this.editVideoData = e.step_id;
      this.showVideo = true;
    },
    back() {
      this.editItem = null;
      this.showProducts = false;
    },
    searchOpearationDescriptions(
      e,
      index,
      search,
      loading,
      onlyIfEmpty = false
    ) {
      if (this.opearationDescriptions[index]?.length > 0 && onlyIfEmpty) return;
      if (!onlyIfEmpty && search.length < 3) return;

      const prev = this.previousSearches[index] || "";
      const isCharRemoved = search.length <= prev.length && prev !== search;
      const currentList = this.opearationDescriptions[index] || [];

      if (
        currentList.length > 0 &&
        currentList.length < 100 &&
        !isCharRemoved
      ) {
        return;
      }

      this.previousSearches[index] = search;

      loading(true);

      http
        .fetch(
          `/manufacturing/operations/descriptions/search?q=${search}&id=${
            e.id || ""
          }`
        )
        .then((data) => {
          this.opearationDescriptions[index] = data;
          loading(false);
        })
        .catch(() => loading(false));
    },
    save(onlyLock = false) {
      if (onlyLock && this.lockData) {
        return;
      }

      let operations = [];
      for (const p of this.operationSteps) {
        if (p.id !== null) {
          if (p.step_id === undefined) {
            delete p.step_id;
          }
          if (p.description === undefined) {
            delete p.description;
          }
          p.name = this.operations.find((e) => e.id === p.id)?.name;
          operations.push(p);
        }
      }
      this.$emit("update:lock", this.lockData);
      this.$emit("update:modelValue", operations);
      if (!onlyLock) {
        this.myModal.hide();
      }
    },
    filterOperations(search, loading) {
      loading(true);
      this.filterQ = search;
      loading(false);
    },
  },
  emits: ["update:modelValue", "update:lock"],
};
</script>
<style scoped>
ul {
  list-style-type: none;
}
.dragArea {
  min-height: 2px;
  margin-bottom: 2em;
}
</style>
